import { render, staticRenderFns } from "./GoalsAndAssists.vue?vue&type=template&id=a868551c&scoped=true&"
import script from "./GoalsAndAssists.vue?vue&type=script&lang=js&"
export * from "./GoalsAndAssists.vue?vue&type=script&lang=js&"
import style0 from "./GoalsAndAssists.vue?vue&type=style&index=0&id=a868551c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a868551c",
  null
  
)

export default component.exports